export const Events = {
  OPEN: 'OPEN_APP',
  PAYMENTDONE: 'PAYMENT_DONE',
  EXIT: 'CLOSE',
  PAYMENTMETHODSELECTION: 'PAYMENT_METHOD_SELECTION',
  CLICKREGISTER: 'CLICK_REGISTER',
  STARTFREETRIAL: 'START_FREE_TRIAL',
};

export const MediaTypes = {
  VIDEO: 'VIDEO',
  STORIES: 'STORIES',
  GAMES: 'GAMES',
  FOLDER: 'FOLDER',
  SOUND_CARD: 'SOUND_CARD',
};

export const Platform = {
  Android: 'Android',
  AndroidTV: 'AndroidTV',
  appleTv: 'appleTv',
  IOS: 'IOS',
  WEB: 'WEB'
};

export const DeviceType = {
  Tablet: 'Tablet',
  Web: 'WEB',
  Mobile: 'Mobile',
};
export const UserOrigin = {
  ORGANIC: 'Organic',
  ADS: 'Ads',
};

export function hasUtmParams(query) {
  if (!query || Object.keys(query).length === 0) return false;
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  return utmKeys.some((key) => query[key]);
}
// Returns current UTC timestamp in ISO format
export function getCurrentTimestamp() {
  const now = new Date();

  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, '0');
  const day = String(now.getUTCDate()).padStart(2, '0');
  const hours = String(now.getUTCHours()).padStart(2, '0');
  const minutes = String(now.getUTCMinutes()).padStart(2, '0');
  const seconds = String(now.getUTCSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
}

// Detects platform based on navigator.platform
export function getDevice() {
  const platform = navigator.platform || '';
  const userAgent = navigator.userAgent || '';
  let device = 'Unknown';

  // iOS / iPadOS detection (including iPadOS masquerading as Mac)
  if (/iPhone|iPad|iPod/.test(platform) || 
     (/MacIntel/.test(platform) && navigator.maxTouchPoints > 1)) {
    device = Platform.IOS;
  }
  // Android
  else if (/Android/.test(userAgent)) {
    device = Platform.Android;
  }
  // macOS ONLY (excluding iPad masquerading as Mac)
  else if (/Mac/.test(platform) && navigator.maxTouchPoints === 0) {
    device = Platform.WEB;  // Use this to clearly separate macOS
  }
  // Windows
  else if (/Win/.test(platform)) {
    device = Platform.WEB;
  }
  // Linux
  else if (/Linux/.test(platform)) {
    device = 'Linux';
  }

  return device;
}

// Detects device type from user agent string
export function detectDeviceType() {
  const ua = navigator.userAgent.toLowerCase();

  if (/ipad|tablet|kindle|playbook/.test(ua)) {
    return DeviceType.Tablet;
  } else if (/mobi|android|touch/.test(ua)) {
    return DeviceType.Mobile;
  } else {
    return DeviceType.Web;
  }
}

export function hasUtmData() {
  const persistedState = JSON.parse(sessionStorage.getItem('kidjo_accounts'));
  const utmData = persistedState?.analytics?.utmData;
  return utmData;
}
export function initUTMTracking() {
  const utmData = hasUtmData();
  const utmSource = utmData?.utm_source;

  if (process.env.VUE_APP_SHOW_ON_ENV === 'prod' && utmData && Object.keys(utmData).length > 0) {

    // Facebook Pixel loader
    const loadFacebookPixel = () => {
      (function(f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script');

      fbq('init', '1686250881998324');
      fbq('track', 'PageView');
    };

    // Google Tag loader
    const loadGoogleTag = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', 'AW-17553248740');

      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17553248740';
      document.head.appendChild(script);
    };

    if (utmSource === 'google') {
      loadGoogleTag();
    } else {
      loadFacebookPixel();
    }
  }
  return true;
}
